import React from "react";
import { resultColumns } from "./columnsData/columns";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  compactTableProps,
  smallerHeadCellProps,
} from "../../../../../../styles/muiProps";
import {MaterialReactTable} from "material-react-table";

// Edge Mentor code labels for the Shell Result table (DataGridView6).
// These semantic labels match the Edge Mentor Excel/content inventory.
const SHELL_RESULT_EDGE_MENTOR_CODE_LABELS = {
  Allowable_Stress: "shellResultAllowableStress",
  Required_Thickness: "shellResultRequiredThickness",
  UCS_Curve: "shellResultUcsCurve",
  MDMT: "shellResultShellResultMdmt",
  MAWP: "shellResultShellResultMawp",
  Hydrotest_Pressure: "shellResultShellHydrotestPressure",
};

const ResultTable = (props) => {
  const { isLoading } = props;
  const { control } = useFormContext();
  const { fields: resultFields } = useFieldArray({
    control,
    name: "DataGridView6",
  });
  return (
    <MaterialReactTable
      columns={resultColumns}
      data={resultFields ?? []}
      {...compactTableProps}
      {...smallerHeadCellProps}
      enableColumnActions={false}
      initialState={{ density: "compact" }}
      // Fill the stretched grid item so this panel matches the main
      // table panel height (main table itself is untouched).
      muiTablePaperProps={{ sx: { height: "100%" } }}
      state={{
        isLoading: isLoading,
      }}
      muiTableBodyCellProps={({ cell }) => ({
        // Keep calculated/read-only result cells message-capable.
        // The PV-wide EdgeMentorHost reads this marker without changing
        // any table state, calculation logic, or editability.
        "data-edge-mentor":
          SHELL_RESULT_EDGE_MENTOR_CODE_LABELS[cell.column.id] || undefined,
        sx: {
          textAlign: "center",
          borderRight: "1px solid #ddd",
          // Fixed height + vertical centering for uniform rows.
          height: "46px",
          padding: "0 8px",
          verticalAlign: "middle",
        },
      })}
      muiTableBodyRowProps={{
        sx: { height: "46px" },
      }}
      muiEditTextFieldProps={({ cell }) => ({
        sx: {
          "& .MuiInputBase-input": {
            padding: "8.5px 8px",
            textAlign: "center",
          },
        },
      })}
      muiTableHeadCellProps={({ cell }) => ({
        sx: {
          borderRight: "1px solid rgba(224,224,224,1)",
          backgroundColor: "hsla(250, 86%, 97%, 1)",
          fontSize: "16px",
          // Header padding intentionally kept as-is (right table).
          // 3px shorter overall than the default (9.7px vs 11.2px per side).
          py: "9.7px",
        },
      })}
    />
  );
};

export default ResultTable;
